import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initAnalytics } from './analytics/analytics.js';
// Inicializa i18next (idiomas) ANTES de montar React, para que el idioma activo
// esté resuelto en el primer render.
import './i18n/index.js';
import './styles.css';

// Prepara la analítica, pero SIN cargar ningún script de terceros hasta que el
// visitante CONCEDA el consentimiento en el banner de cookies (ePrivacy/GDPR).
// `initAnalytics` solo se suscribe a los cambios de consentimiento y aplica la
// decisión persistida si ya existía. Fuera de React para una sola suscripción.
initAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró #root.');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
